export default "__VITE_ASSET__Z4M0QE7kh1SF5ZpEjP$yXw__"